import React from 'react';
import DesignStatus from '../../../common/components/DesignStatus/DesignStatus';

export default props => (
  <DesignStatus {...props} />
);


// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/status.js